const filters = [
    {
        id: 1,
        filterName: 'type',
        icon: 'type',
        isFirst: true,
        filterType: 'type',
        options: [
            {
                id: 1,
                value: 'Motor Yacht',
                shortName: 'motor',
                name: 'Motor Yacht'
            },
            {
                id: 2,
                value: 'Sailing Yacht',
                shortName: 'sail',
                name: 'Sailing Yacht'
            },
            {
                id: 3,
                value: 'RIB',
                shortName: 'rib',
                name: 'RIB'
            }
        ]
    },
    {
        id: 6,
        filterName: 'brand',
        icon: 'brand',
        filterType: 'brand',
        options: []
    },
    {
        id: 2,
        filterName: 'condition',
        icon: 'condition',
        isCondition: true,
        filterType: 'condition',
        options: [
            {
                id: 1,
                value: 'New',
                shortName: 'New',
                name: 'New Yacht'
            },
            {
                id: 2,
                value: 'new-stock',
                shortName: 'new-stock',
                name: 'New Yacht Stock'
            },
            {
                id: 3,
                value: 'Pre-owned',
                shortName: 'Pre-owned',
                name: 'Pre-owned Yacht'
            }
        ]
    },
    {
        id: 3,
        filterName: 'year',
        icon: 'year',
        filterType: 'year',
        options: [
            {
                id: 1,
                min: 0,
                max: 1990,
                name: '< 1990'
            },
            {
                id: 2,
                min: 1990,
                max: 1995,
                name: '1990 - 1995'
            },
            {
                id: 3,
                min: 1995,
                max: 2000,
                name: '1995 - 2000'
            },
            {
                id: 4,
                min: 2000,
                max: 2005,
                name: '2000 - 2005'
            },
            {
                id: 5,
                min: 2005,
                max: 2010,
                name: '2005 - 2010'
            },
            {
                id: 6,
                min: 2010,
                max: 2015,
                name: '2010 - 2015'
            },
            {
                id: 7,
                min: 2015,
                max: 2020,
                name: '2015 - 2020'
            },
            {
                id: 8,
                min: 2020,
                max: 2025,
                name: '2020 - 2025'
            }
        ]
    },
    {
        id: 4,
        filterName: 'length',
        icon: 'length',
        isLength: true,
        filterType: 'length',
        options: [
            {
                id: 1,
                min: 10,
                max: 15,
                name: '10 - 15 m'
            },
            {
                id: 2,
                min: 15,
                max: 20,
                name: '15 - 20 m'
            },
            {
                id: 3,
                min: 20,
                max: 25,
                name: '20 - 25 m'
            },
            {
                id: 4,
                min: 25,
                max: 30,
                name: '25 - 30 m'
            },
            {
                id: 5,
                min: 30,
                max: 35,
                name: '30 - 35 m'
            },
            {
                id: 6,
                min: 35,
                max: 40,
                name: '35 - 40 m'
            },
            {
                id: 7,
                min: 40,
                max: 50,
                name: '40 - 50 m'
            },
            {
                id: 8,
                min: 50,
                max: Number.POSITIVE_INFINITY,
                name: '> 50 m'
            }
        ]
    },
    {
        id: 5,
        filterName: 'price',
        icon: 'price',
        filterType: 'price',
        options: [
            {
                id: 1,
                min: 0,
                max: 100000,
                name: '< 100.000 €'
            },
            {
                id: 2,
                min: 100000,
                max: 500000,
                name: '100.000 - 500.000 €'
            },
            {
                id: 3,
                min: 500000,
                max: 1000000,
                name: '500.000 - 1.000.000 €'
            },
            {
                id: 4,
                min: 1000000,
                max: 5000000,
                name: '1.000.000 - 5.000.000 €'
            },
            {
                id: 5,
                min: 5000000,
                max: 10000000,
                name: '5.000.000 - 10.000.000 €'
            },
            {
                id: 6,
                min: 10000000,
                max: 15000000,
                name: '10.000.000 - 15.000.000 €'
            },
            {
                id: 7,
                min: 15000000,
                max: 30000000,
                name: '15.000.000 - 30.000.000 €'
            },
            {
                id: 8,
                min: 30000000,
                max: Number.POSITIVE_INFINITY,
                name: '> 30.000.000 €'
            }
        ]
    }
]

export default filters
